<template>
  <v-layout
    v-if="loading"
    justify-center
    class="mt-5"
  >
    <v-progress-circular
      :color="colour"
      indeterminate
    />
  </v-layout>
</template>

<script>
import lodash from 'lodash';

export default {
  name: 'ElacSharedLoader',

  props: {
    value: { type: Boolean },
    colour: { type: String, default: 'primary' },
    permanent: { type: Boolean },
  },

  data: () => ({
    loading: false,
    stop: false,
  }),

  watch: {
    value(v) {
      // Don't show the loader right away
      if (v) {
        this.stop = false;
        return this.bounced();
      }

      this.stop = true;
      this.loading = false;
      return null;
    },
  },

  mounted() {
    if (this.permanent) {
      this.loading = true;
    }
  },

  methods: {
    // eslint-disable-next-line func-names
    bounced: lodash.debounce(function() {
      if (this.stop) {
        return;
      }

      this.loading = true;
    }, 500),
  },
};
</script>
